/**
 * The content pages the site shows (DV-158), each a path routed to the slug
 * the backend serves it under (backend/src/pages Registry). Adding a page is
 * a line here, after the backend's. `nameKey` names it in the `pages`
 * namespace and in the footers.
 */
export const PUBLIC_PAGES = [
  { path: "/privacy", slug: "privacy", nameKey: "privacy" },
  { path: "/refund-policy", slug: "refund-policy", nameKey: "refundPolicy" },
] as const

export type PublicPage = (typeof PUBLIC_PAGES)[number]

/** The page a slug names, if the dashboard routes it. */
export const pageOf = (slug: string): PublicPage | undefined =>
  PUBLIC_PAGES.find((p) => p.slug === slug)
